export default function SimpleCTAToDialogCard({
  title,
  desc,
  ctaText,
  openDialog,
}) {
  return (
    <div className="ui-card p-4 xl:p-6">
      <div className="text-xl font-semibold">{title}</div>
      <hr />
      <p className="text-xs">{desc}</p>
      <div className="text-right mt-4 xl:mt-6">
        <button className="ui-btn-primary" onClick={openDialog}>
          {ctaText}
          <span className="sr-only"> {title}</span>
        </button>
      </div>
    </div>
  );
}
